module.exports = __webpack_public_path__ + "promo-codes.svg?b767efcae2e9f812e4a6b1666a7e8289";